saveStateToLocalStorage = (store) ->
  store.subscribe (mutation, state) ->
    mutation.payload ||= {}
    if mutation.type.includes('💾') || mutation.payload.cache_localstorage == true
      requestIdleCallback ->
        new_state =
          account_categories: store.getters.account_categories
          accounts: state.user.accounts
          currencies: state.user.currencies
          prices: state.user.prices
          user: state.user.userdata
          all_virtuals: state.user.virtuals
          intercom_data: state.user.intercom_data
        localStorage.setItem('hm_state', JSON.stringify(new_state))
        ldb.set('hm_transactions', JSON.stringify(state.user.transactions))
    return true

displayMutations = (store) ->
  return if HM.is_production
  store.subscribe (mutation, state) ->
    payload = mutation.payload || ''
    payload = '' if Array.isArray(payload)
    #   constructor_name = payload[0]?.constructor?.name || ''
    #   payload = "[#{constructor_name} (#{payload.length})]"
    log.info.divider mutation.type, payload

displayActions = (store) ->
  return if HM.is_production
  store.subscribeAction (action, state) ->
    payload = action.payload || ''
    payload = '' if Array.isArray(payload)
    #   constructor_name = payload[0]?.constructor?.name || ''
    #   payload = "[#{constructor_name} (#{payload.length})]"
    log.warning.divider action.type, payload

module.exports =
  saveStateToLocalStorage: saveStateToLocalStorage
  displayMutations: displayMutations
  displayActions: displayActions
